import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const BenefitSection = lazy(() => import("./BenefitSection"));
const IotSection = lazy(() => import("./IotSection"));
const SolutionSection = lazy(() => import("./SolutionSection"));
const WhyChooseSection = lazy(() => import("./WhyChooseSection"));

const Energy = () => {
  return (
    <main className="bg-white">
      <Helmet>
        <title>
          IoT Energy Solutions | Smart & Sustainable Energy Management
        </title>

        <meta
          name="description"
          content="Optimize your energy systems with LENTERA’s IoT solutions. Enable real-time monitoring, predictive maintenance, smart grid management and renewable energy integration for enhanced efficiency, cost reduction and sustainable operations."
        />

        <meta
          name="keywords"
          content="LENTERA energy IoT, automated energy control, real-time energy monitoring, sustainable energy solutions, AI-powered energy systems."
        />
      </Helmet>

      <HeroSection />

      <Suspense
        fallback={
          <div
            role="status"
            aria-live="polite"
            className="h-[400px] flex items-center justify-center"
          >
            Loading...
          </div>
        }
      >
        <BenefitSection />
        <IotSection />
        <SolutionSection />
        <WhyChooseSection />
      </Suspense>
    </main>
  );
};

export default Energy;